import type { DirectoryNodePermissions } from './types';

const DEFAULT_POSITIONS = [
  { id: 'pos-almoxarife', name: 'Almoxarife', allowed: true },
  { id: 'pos-almoxarife-ma', name: 'Almoxarife (MA)', allowed: true },
  { id: 'pos-almoxarife-jr', name: 'Almoxarife Jr', allowed: true },
  { id: 'pos-analista-jr', name: 'Analista Comercial Jr', allowed: true },
  { id: 'pos-analista-pl', name: 'Analista Comercial Pl', allowed: false },
];

const DEFAULT_FUNCTIONAL_ACTIVITIES = [
  { id: 'fa-auditor', name: 'Auditor Interno', allowed: false },
  { id: 'fa-brigadista', name: 'Brigadista', allowed: false },
  { id: 'fa-cipa', name: 'CIPA', allowed: false },
];

export function getMockPermissionsForNode(): DirectoryNodePermissions {
  return {
    superadmin: false,
    positions: DEFAULT_POSITIONS.map((entry) => ({ ...entry })),
    functionalActivities: DEFAULT_FUNCTIONAL_ACTIVITIES.map((entry) => ({ ...entry })),
  };
}
